import template from './hueb-seo-conversion-detail.html.twig';
import './hueb-seo-conversion-detail.scss';

const {Component, Mixin} = Shopware;
const {mapPropertyErrors} = Shopware.Component.getComponentHelper();
const {Criteria} = Shopware.Data;

Component.register('hueb-seo-conversion-detail', {
    template,
    inject: [
        'systemConfigApiService', 'repositoryFactory', 'cacheApiService'
    ],

    mixins: [
        Mixin.getByName('notification')
    ],

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    data() {
        return {
            conversionData: null,
            allConfigs: {},
            isLoading: false,
            repository: null,
        };
    },


    created() {
        this.repository = this.repositoryFactory.create('hueb_seo_config');
        this.getConversionData();
    },

    methods: {
        async getConversionData() {
            this.isLoading = true;
            const criteria = new Criteria();
            await this.repository
                .search(criteria, Shopware.Context.api)
                .then((result) => {
                    if (result.length === 0) {
                        this.$router.push({name: 'hueb.seo.conversion.create'});
                    }
                    this.conversionData = result.first();
                    this.isLoading = false;
                }).catch((exception) => {
                    this.createNotificationError({
                        title: this.$t('hueb-seo-conversion.detail.errorTitle'),
                        message: exception
                    });
                    this.isLoading = false;
                });
        },

        onClickSave() {
            this.isLoading = true;
                //this.conversionData.headline = this.conversionData.translated.headline;

                this.repository
                    .save(this.conversionData, Shopware.Context.api)
                    .then(() => {
                        this.getConversionData();
                        this.isLoading = false;
                    }).catch((exception) => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: this.$t('hueb-seo-conversion.detail.errorTitle'),
                        message: exception
                    });
                });

        },

        onChangeLanguage() {
            this.getConversionData();
        },

    }
});
